export const CatalogsKeys = {
  OFICINAS: 'c_oficinas',
  TIPOS_ID: 'c_tiposID',
  ESTADO_CIVIL: 'c_estadoCivil',
  TIPOS_DOCUMENTOS: 'c_tiposDocumentos',
};